import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import type { Response } from "../interfaces";

export type EvabotOrder = Record<string, string | number | boolean | null>;

export interface EvabotChat {
  AutoId: number;
  UserId: number | null;
  UrlId: number | null;
  Question: string | null;
  QuizId: number | null;
  Message: string | null;
  Type: string | null;
  Tag: string | null;
  IsUndo: number | null;
  DateTime: string | null;
}

export interface EvabotOrderResult {
  order: EvabotOrder;
  chats: EvabotChat[];
}

export interface EvabotOrderSummary {
  UrlId: number;
  FlowId: number | null;
  PackId: number | null;
  Name: string | null;
  Email: string | null;
  ReceiverEmail: string | null;
  Occasion: string | null;
  Relationship: string | null;
  GiftStatus: string | null;
  GiftType: number | null;
  SendVia: number | null;
  Mobile: string | null;
  Url: string | null;
  DeliveryDate: string | null;
  DateTime: string | null;
  LastUpdatedOn: string | null;
  AcceptedOn: string | null;
  ShippedOn: string | null;
  DeliveredOn: string | null;
  PaymentStatus: string | null;
  IsDelete: number | null;
}

export interface EvabotSearchResult {
  orders: EvabotOrderSummary[];
}

export const evabotDataApi = createApi({
  reducerPath: "evabotDataApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    searchEvabotOrders: builder.query<Response<EvabotSearchResult>, string>({
      query: (email) => ({
        url: "admin/evabot-data/search",
        method: "GET",
        params: { email },
      }),
    }),
    getEvabotOrder: builder.query<Response<EvabotOrderResult>, number>({
      query: (orderNumber) => ({
        url: `admin/evabot-data/${orderNumber}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazySearchEvabotOrdersQuery,
  useLazyGetEvabotOrderQuery,
} = evabotDataApi;
